<h2 i18n>Information about the Writer</h2>
<form (ngSubmit)="next()" (keydown.enter)="$event.preventDefault()">
    @if (error) {
    <div class="alert alert-danger" role="alert">
        {{error}}
    </div>
    }
    @switch (page)
    {
    @case (1) {
    <p i18n>
        Please provide the following information about the person who wrote the letter(s) you are submitting.
    </p>

    <p i18n>
        Please give the writer's month and year of birth. If you are not sure, please give estimated dates and tick the
        "approximate" box:
    </p>

    <ell-survey-question i18n-question question="MM/YY" type="month-field" [(answer)]="answers['birthMonth']"
        name="birthMonth" />
    <ell-survey-question i18n-question question="Approximate?" type="checkbox"
        [(answer)]="answers['birthDateApproximate']" name="birthDateApproximate" />

    <hr>

    <p i18n>
        Please give the writer's month and year of death.
    </p>

    <ell-survey-question i18n-question question="MM/YY" type="month-field" [(answer)]="answers['deathMonth']"
        name="deathMonth" />
    <ell-survey-question i18n-question question="Approximate?" type="checkbox"
        [(answer)]="answers['deathDateApproximate']" name="deathDateApproximate" />

    <hr>

    <ell-survey-question i18n-question question="What was the writer's country of birth?" type="dropdown-select"
        [other]="true" [options]="countryOptions" [(answer)]="answers['birthCountry']" name="birthCountry" />

    <ell-survey-question i18n-question question="How would you describe the writer's ethnic group?" type="text-field"
        [(answer)]="answers['ethnicity']" name="ethnicity" />

    <ell-survey-question i18n-question question="What was/were the writer's first language(s)?" type="text-field"
        [(answer)]="answers['firstLanguages']" name="firstLanguages" />

    <ell-survey-question i18n-question question="What other languages did the writer use?" type="text-field"
        [(answer)]="answers['otherLanguages']" name="otherLanguages" />

    <ell-survey-question i18n-question question="What was the writer's sex at birth?" type="radio-select"
        [(answer)]="answers['birthSex']" name="birthSex" [options]="sexOptions" />

    <ell-survey-question i18n-question
        question="Was their gender at the time of their death the same as their sex at birth?" type="yesno"
        [(answer)]="answers['genderSame']" name="genderSame" />

    @if (answers.birthSex === sexOptions[2] || !answers['genderSame']) {
    <ell-survey-question i18n-question question="You can give further information here:" type="text-field"
        [(answer)]="answers['genderDetails']" name="genderDetails" />
    }

    <ell-survey-question i18n-question question="What was the writer's marital status at the time of their death?"
        type="radio-select" [(answer)]="answers['marital']" name="marital" [options]="maritalOptions" [other]="true" />

    <ell-survey-question i18n-question question="What was the writer's last occupation, if known?" type="text-field"
        [(answer)]="answers['occupation']" name="occupation" />

    <ell-survey-question i18n-question
        question="What country was the person normally resident in at the time of their death?" type="dropdown-select"
        [other]="true" [options]="countryOptions" [(answer)]="answers['residencyCountry']" name="residencyCountry" />

    <ell-survey-question i18n-question question="In which country did the person die?" type="dropdown-select"
        [other]="true" [options]="countryOptions" [(answer)]="answers['deathCountry']" name="deathCountry" />

    <ell-survey-question i18n-question question="How did the person's life end?" type="radio-select"
        [(answer)]="answers['deathMethod']" name="deathMethod" [options]="deathOptions" [other]="true" />

    <p i18n>Do you wish to provide any further information about the writer or the circumstances in which they ended
        their life? For example, had they previously done military service? Was there an inquest into the cause of
        death, and if so what was the verdict? Were they seriously/terminally ill at the time of their death?</p>

    <p><em i18n>(Any information which could identify them or anyone else will be anonymised)</em></p>

    <p>Please see the <a [routerLink]="['/', 'privacy']" target="_blank">Privacy Statement</a> for information on how
        data on living persons is processed.</p>

    <ell-survey-question i18n-question question="Further information" type="textarea"
        [(answer)]="answers['deathDetails']" name="deathDetails" />
    }
    }

    <input type="submit" class="btn btn-primary" value="Next" i18n-value />
</form>